export default "__VITE_ASSET__gBgbQCdB__"